import { Card } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import { RotaryList_rotarys_edges_node } from "@saleor/rotary/types/RotaryList";
import { RotaryListUrlSortField } from "@saleor/rotary/urls";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  SortPage,
  TabPageProps
} from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import RotaryList from "../RotaryList";
import {
  createFilterStructure,
  RotaryFilterKeys,
  RotaryListFilterOpts
} from "./filters";

export interface RotaryListPageProps
  extends PageListProps,
    ListActions,
    FilterPageProps<RotaryFilterKeys, RotaryListFilterOpts>,
    SortPage<RotaryListUrlSortField>,
    TabPageProps {
  rotary: RotaryList_rotarys_edges_node[];
  onApply: (rotary: any) => any;
  onCopy: (rotary: any) => any;
  onBack: () => void;
  toatlCount:number;
}

const RotaryListPage: React.FC<RotaryListPageProps> = ({
  currencySymbol,
  filterOpts,
  initialSearch,
  onAdd,
  onBack,
  onFilterChange,
  onSearchChange,
  currentTab,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  onApply,
  onCopy,
  toatlCount,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);

  return (
    <Container>
      <AppHeader onBack={onBack}>
        <FormattedMessage {...sectionNames.configuration} />
      </AppHeader>
      <PageHeader title={intl.formatMessage(sectionNames.rotary)+"("+toatlCount+")"}>
        <Button onClick={onAdd} color="primary" variant="contained">
          <FormattedMessage
            defaultMessage="Create New Rotary"
            description="button"
          />
        </Button>
      </PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All Rotarys",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          filterStructure={structure}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Rotary"
          })}
          tabs={tabs}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <RotaryList onApply={onApply} onCopy={onCopy} {...listProps} />
      </Card>
    </Container>
  );
};
export default RotaryListPage;
